module.exports = __webpack_public_path__ + "img/8H.d13731f1.png";